import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `elplan_bid_matrix` component.
 * Keep in sync with ElplanBidMatrixProps in src/ui/uiConfig/components/ElplanBidMatrix/ElplanBidMatrix.types.ts
 */
export const elplanBidMatrixPropDocs: ComponentDocMap = {
  description: {
    description: 'Introductory text shown above the matrix table.',
    type: 'string',
    example: '"__Latest generated bid matrix"',
  },
  electricity_price_scenario_id: {
    description: 'Scenario ID used when requesting bid matrix data from backend.',
    type: 'number | string',
    example: '4',
  },
}
